const trackGMT = (payload = {}) => {
  if (global.scrollTo) {
    global.dataLayer = global.dataLayer || []
    global.dataLayer.push(payload)
  }
}

export default trackGMT
